function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20012237_42298)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.3839 22.779C18.7059 23.007 19.1209 23.064 19.4909 22.924C19.8609 22.783 20.1329 22.467 20.2149 22.084C21.0839 18 23.1919 7.66303 23.9829 3.94803C24.0429 3.66803 23.9429 3.37703 23.7229 3.19003C23.5029 3.00303 23.1979 2.94903 22.9259 3.05003C18.7329 4.60203 5.81991 9.44703 0.54191 11.4C0.20691 11.524 -0.0110904 11.846 -9.04275e-05 12.199C0.0119096 12.553 0.24991 12.86 0.59291 12.963C2.95991 13.671 6.06691 14.656 6.06691 14.656C6.06691 14.656 7.51891 19.041 8.27591 21.271C8.37091 21.551 8.58991 21.771 8.87891 21.847C9.16691 21.922 9.47491 21.843 9.68991 21.64C10.9059 20.492 12.7859 18.717 12.7859 18.717C12.7859 18.717 16.3579 21.336 18.3839 22.779ZM7.37391 14.102L9.05291 19.64L9.42591 16.133C9.42591 16.133 15.9129 10.282 19.6109 6.94703C19.7189 6.84903 19.7339 6.68503 19.6439 6.57003C19.5549 6.45503 19.3909 6.42803 19.2679 6.50603C14.9819 9.24303 7.37391 14.102 7.37391 14.102Z",
  fill: "#E5E7EB"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20012237_42298"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3752fcb80449a73454b1453abb2edcdc.svg";
export { ForwardRef as ReactComponent };